import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { WSMutationConfig } from "@ws-react-query";
import { useWSMutation } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import {
  updateRequirement,
  WSRequirementUpdateRequest
} from "../../../services/requirements/updateRequirement";
import { QUERY_REQUIREMENT } from "../keys";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { REQUIREMENTS_DEPENDENCIES } from "../../../modules/Requirements/dependencies";
import {
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
  QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE
} from "../../payeeEngagements/keys";
import { queriesPayeeRows } from "@query";
import { QUERY_PAYEE } from "../../payee/keys";
import { QUERY_PAYEE_ROWS } from "../../search/payee/queries/useQueryPayeeRows";
import { QUERY_PAYEE_ROWS_SUMMARY } from "../../search/payee/queries/useQueryPayeeRowsSummary";

type RequirementUpdateRequest = WSRequirementUpdateRequest & {
  requirementId: string;
};

export const useMutationUpdateRequirement = (
  config?: WSMutationConfig<IRequirementResponse, WSServiceError>
) => {
  const xWingspanPayerId = useXWingspanPayerId();

  return useWSMutation(
    ({ requirementId, ...request }: RequirementUpdateRequest) =>
      updateRequirement(requirementId, request, xWingspanPayerId),
    {
      ...config,
      dependencies: [
        ...REQUIREMENTS_DEPENDENCIES,
        QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
        QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE,
        QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
        QUERY_PAYEE,
        QUERY_PAYEE_ROWS,
        QUERY_PAYEE_ROWS_SUMMARY,
        queriesPayeeRows.searchPayeeRows.queryKeyBase
      ],
      awaitDependencies(result, { requirementId }) {
        return [[QUERY_REQUIREMENT, requirementId]];
      }
    }
  );
};
